function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "customer interaction") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M206.214,345.106a7.006,7.006,0,0,1-.46-2.48c-.021-8.689-.076-18.579-.14-19.79a89.964,89.964,0,0,0-90.053-85.263c-.343,0-.685,0-1.029.006q-1.171.012-2.335.055c-2.213.079-4.405.257-6.58.51a89.923,89.923,0,0,1,80,84.692c.064,1.211.119,11.1.14,19.79a7.006,7.006,0,0,0,.46,2.48l17.262,45.215h20Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.107,443.648h-.089A20.907,20.907,0,0,0,107.7,459.489L100.9,486.546h20l6.806-27.057a20.9,20.9,0,0,1,18.451-15.756Q139.3,443.7,128.107,443.648Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.714,397.321v31.9A14.588,14.588,0,0,1,158.986,443.7c10.785.051,16.745.092,17.714.122a14.6,14.6,0,0,0,15.014-14.6v-31.9a7,7,0,0,1,7-7h-20A7,7,0,0,0,171.714,397.321Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.246,342.626c.021-8.689.076-18.579.142-19.824a89.884,89.884,0,0,1,71.085-83.23v-1.993h0a89.926,89.926,0,0,0-91.08,85.223c-.066,1.245-.121,11.135-.142,19.824a7.006,7.006,0,0,1-.46,2.48l-17.262,45.215h20l17.262-45.215A7.006,7.006,0,0,0,326.246,342.626Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.2,427.039a7,7,0,0,0-7-6.9h-20a7,7,0,0,1,6.994,6.9l.081,5.578L371.5,432.5c.6,0,1.191-.039,1.782-.085Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.286,420.14V397.321a7,7,0,0,0-7-7h-20a7,7,0,0,1,7,7V420.14Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.316,446.377a39.6,39.6,0,0,0,36.543-39.862l-.063-6.778a36.31,36.31,0,0,0,30.3-36.3l-.049-3.662A36.4,36.4,0,0,0,431.473,324.6V245.282a81.08,81.08,0,0,0-20-6.382v85.7a36.4,36.4,0,0,1,29.576,35.181l.049,3.662a36.31,36.31,0,0,1-30.3,36.3l.063,6.778a39.6,39.6,0,0,1-36.543,39.862A20.9,20.9,0,0,1,384.3,459.49l6.8,27.056h20l-6.8-27.056A20.9,20.9,0,0,0,394.316,446.377Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.1,146.993a7,7,0,0,0-6.819-5.418H89.093a14.315,14.315,0,0,1-14.3-14.3V29.753a14.208,14.208,0,0,1,.663-4.3H59.093a14.315,14.315,0,0,0-14.3,14.3v97.523a14.315,14.315,0,0,0,14.3,14.3H88.282a7,7,0,0,1,6.819,5.418l8.318,35.836,25.729-28.4Z",
    style: {
      fill: "#d4e1f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.008,365.422a97.18,97.18,0,0,0-2.371-94.021A95.371,95.371,0,0,0,400.3,223.643q-1.337-.048-2.681-.063A103.886,103.886,0,0,0,292.41,322c-.1,1.68-.146,13.92-.161,19.309l-18.192,47.654a11.321,11.321,0,0,0,10.576,15.357h21.653V420.2a20.152,20.152,0,0,0-19.024,20.425,20.236,20.236,0,0,0,20.217,19.908h.233l38.976-.6A6.971,6.971,0,0,0,351.7,457.7c4.13-.021,8.464-.04,12.256-.056a6.954,6.954,0,0,1,6.769,5.256l8.136,32.35a7,7,0,0,0,6.789,5.292h90.536a7,7,0,0,0,6.763-8.8c-.15-.565-15.014-56.926-11.744-92.059C471.939,391.748,479.134,372.564,482.008,365.422ZM405,386.233h-.209a22.354,22.354,0,0,1-22.3-22l-.049-3.662a22.307,22.307,0,0,1,22.1-22.606h.21a22.354,22.354,0,0,1,22.3,22l.049,3.662A22.307,22.307,0,0,1,405,386.233Zm-97.477,60.3h-.07a6.2,6.2,0,0,1-4.436-10.521,6.115,6.115,0,0,1,4.288-1.87h32l.173,11.9Zm12.761-26.39V397.321a7,7,0,0,0-7-7H288.524l17.262-45.215a7.006,7.006,0,0,0,.46-2.48c.021-8.689.076-18.579.142-19.824a89.926,89.926,0,0,1,91.08-85.223h0V324.69a36.319,36.319,0,0,0-29.03,36.065l.049,3.662a36.4,36.4,0,0,0,28.3,34.914l.068,7.315A25.62,25.62,0,0,1,371.5,432.5l-18.215.113-.081-5.578a7,7,0,0,0-7-6.9Zm149.152-60.89c-.1.2-.2.4-.284.614-1.1,2.727-10.818,26.978-11.893,38.523-2.729,29.308,5.776,70.313,9.975,88.159H391.1l-6.8-27.056a20.9,20.9,0,0,0-9.981-13.113,39.6,39.6,0,0,0,36.543-39.862l-.063-6.778a36.31,36.31,0,0,0,30.3-36.3l-.049-3.662A36.4,36.4,0,0,0,411.473,324.6V238.9a81.522,81.522,0,0,1,56.061,39.54A83.249,83.249,0,0,1,469.438,359.25Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.8,399.685c3.27,35.133-11.594,91.494-11.744,92.059a7,7,0,0,0,6.763,8.8h90.536a7,7,0,0,0,6.789-5.292l8.137-32.351a6.937,6.937,0,0,1,6.739-5.255h.029c23.926.1,27.7.148,28.215.164a28.768,28.768,0,0,0,20.763-8.061,28.354,28.354,0,0,0,8.687-20.528v-24.9h21.653a11.322,11.322,0,0,0,10.576-15.358L219.751,341.31c-.015-5.389-.06-17.625-.158-19.263a103.921,103.921,0,0,0-104.029-98.474c-.391,0-.793,0-1.186.007q-1.346.013-2.683.063A95.37,95.37,0,0,0,32.363,271.4a97.18,97.18,0,0,0-2.371,94.021C32.866,372.564,40.061,391.748,40.8,399.685ZM44.466,278.44A81.438,81.438,0,0,1,112.2,237.634q1.164-.042,2.335-.055c.344,0,.686-.006,1.029-.006a89.964,89.964,0,0,1,90.053,85.263c.064,1.211.119,11.1.14,19.79a7.006,7.006,0,0,0,.46,2.48l17.262,45.215H198.714a7,7,0,0,0-7,7v31.9a14.6,14.6,0,0,1-15.014,14.6c-1.257-.039-10.877-.1-28.593-.171h-.089A20.907,20.907,0,0,0,127.7,459.489L120.9,486.546H44.764c4.2-17.846,12.7-58.852,9.975-88.159-1.075-11.545-10.789-35.8-11.893-38.523-.085-.209-.179-.413-.284-.614A83.249,83.249,0,0,1,44.466,278.44Z",
    style: {
      fill: "#2f55d4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.188,212.142a7,7,0,0,0,12.006-3.118l10.085-43.449h23.628a28.331,28.331,0,0,0,28.3-28.3V39.753a28.33,28.33,0,0,0-28.3-28.3H59.093a28.33,28.33,0,0,0-28.3,28.3v97.523a28.331,28.331,0,0,0,28.3,28.3H82.721l10.085,43.449a7,7,0,0,0,12.006,3.118l42.193-46.567H365ZM143.9,151.575a7,7,0,0,0-5.187,2.3l-35.295,38.954L95.1,156.993a7,7,0,0,0-6.819-5.418H59.093a14.315,14.315,0,0,1-14.3-14.3V39.753a14.315,14.315,0,0,1,14.3-14.3H452.907a14.315,14.315,0,0,1,14.3,14.3v97.523a14.315,14.315,0,0,1-14.3,14.3H423.718a7,7,0,0,0-6.819,5.418l-8.318,35.836-35.3-38.954a7,7,0,0,0-5.187-2.3Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.877,125.43a7,7,0,0,0-7-7H233.62a7,7,0,0,0,0,14H419.877A7,7,0,0,0,426.877,125.43Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.482,118.43H163.743a7,7,0,0,0,0,14h47.739a7,7,0,1,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.877,82.829H395.02a7,7,0,0,0,0,14h24.857a7,7,0,0,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.564,82.829a7,7,0,0,0,0,14H371.579a7,7,0,0,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.717,61.228h79.16a7,7,0,0,0,0-14h-79.16a7,7,0,0,0,0,14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.617,118.43H72.792a7,7,0,0,0,0,14h62.825a7,7,0,1,0,0-14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.271,89.829a7,7,0,0,0-7-7H72.792a7,7,0,0,0,0,14H232.271A7,7,0,0,0,239.271,89.829Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.111,61.228H317.46a7,7,0,0,0,0-14H153.111a7,7,0,0,0,0,14Z",
    style: {
      fill: "#2eca8b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.792,61.228h57.062a7,7,0,0,0,0-14H72.792a7,7,0,0,0,0,14Z",
    style: {
      fill: "#2eca8b"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customer-service.ff3088bb72f2d286cf8afad5824d74ce.svg";
export { ForwardRef as ReactComponent };